<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="未使用" name="card0">
        <span slot="label">未使用（{{ couponTab0 }}）</span>
        <myCoupon ref="childRef0" :status="0" />
      </el-tab-pane>
      <el-tab-pane label="已使用" name="card1">
        <span slot="label">已使用（{{ couponTab1 }}）</span>
        <myCoupon ref="childRef1" :status="1" />
      </el-tab-pane>
      <el-tab-pane label="已过期" name="card2">
        <span slot="label">已过期（{{ couponTab2 }}）</span>
        <myCoupon ref="childRef2" :status="2" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import myCoupon from './myCoupon.vue'
import { mapState } from 'vuex'
export default {
  name: 'MyCouponIndex',
  components: {
    myCoupon
  },
  computed: {
    ...mapState(['couponTab0', 'couponTab1', 'couponTab2'])
  },
  data() {
    return {
      activeName: 'card0'
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleClick(tab) {
      this.$refs['childRef' + [tab.index]].getCouponCardList()
    }
  }
}

</script>
<style scoped>
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.colorRed{
  color: red
}
</style>
